import React, { useEffect, useState } from "react";
import "./SalesDemo.css";
import iconfevi from "../../src/assets/images/favicon.ico";
import profile from "../../src/assets/images/c3.jpg";
import "font-awesome/css/font-awesome.min.css";
import crmimg1 from "../../src/assets/images/crm-dashboard.png";

const AUTO_CHANGE_TIME = 1000; // 10000 = 10 sec, 20000 = 20 sec

const crmModules = [
  {
    section: "Overview",
    key: "Dashboard",
    icon: "fa fa-tachometer",
    label: "Dashboard",
    title: "Dashboard",
    slug: "Dashboard",
    color: "#e94fc6",
    image: crmimg1,
  },
  {
    section: "Overview",
    key: "Leads",
    icon: "fa fa-briefcase",
    label: "Leads",
    title: "Leads",
    slug: "Leads",
    color: "#ef453d",
    image: "Leads",
  },
  {
    section: "Overview",
    key: "Follow Ups",
    icon: "fa fa-line-chart",
    label: "Follow Ups",
    title: "Follow Ups",
    slug: "Follow-Ups",
    color: "#f7a018",
    image: "Follow Ups",
  },
  {
    section: "Overview",
    key: "Interactions",
    icon: "fa fa-comments",
    label: "Interactions",
    title: "Interactions",
    slug: "Interactions",
    color: "#3468f6",
    image: "Interactions",
  },
  {
    section: "Overview",
    key: "Portfolio Reviews",
    icon: "fa fa-area-chart",
    label: "Portfolio Reviews",
    title: "Portfolio Reviews",
    slug: "Portfolio Reviews",
    color: "#12b998",
    image: "Portfolio Reviews",
  },
  {
    section: "Overview",
    key: "My Task",
    icon: "fa fa-check-square-o",
    label: "My Task",
    title: "My Task",
    slug: "My Task",
    color: "#e53845",
    image: "My Task",
  },
  {
    section: "Overview",
    key: "Client Greetings",
    icon: "fa fa-bullseye",
    label: "Client Greetings",
    title: "Client Greetings",
    slug: "Client Greetings",
    color: "#d9733a",
    image: "Client Greetings",
  },
  {
    section: "Overview",
    key: "Contact Us",
    icon: "fa fa-address-book-o",
    label: "Contact Us",
    title: "Contact Us",
    slug: "Contact Us",
    color: "#2ab66c",
    image: "Contact Us",
  },
  {
    section: "Overview",
    key: "Opportunity",
    icon: "fa fa-suitcase",
    label: "Opportunity",
    title: "Opportunity",
    slug: "Opportunity",
    color: "#55b7f2",
    image: "Opportunity",
  },
  {
    section: "Overview",
    key: "Transactions",
    icon: "fa fa-exchange",
    label: "Transactions",
    title: "Transactions",
    slug: "Transactions",
    color: "#8957e5",
    image: "Transactions",
  },
  {
    section: "Report",
    key: "No Activity Report",
    icon: "fa fa-bar-chart",
    label: "No Activity Report",
    title: "No Activity Report",
    slug: "No Activity Report",
    color: "#9854e8",
    image: "No Activity Report",
  },
  {
    section: "Management",
    key: "User Management",
    icon: "fa fa-id-card-o",
    label: "User Management",
    title: "User Management Details",
    slug: "User Management-details",
    color: "#607d8b",
    image: "User Management",
  },
  {
    section: "Management",
    key: "Team Management",
    icon: "fa fa-users",
    label: "Team Management",
    title: "Team Management Details",
    slug: "Team Management-details",
    color: "#3f51b5",
    image: "Team Management",
  },
  {
    section: "Marketplace",
    key: "Integration",
    icon: "fa fa-cogs",
    label: "Integration",
    title: "Integration Details",
    slug: "Integration-details",
    color: "#009688",
    image: "Integration",
  },
];

const sidebarSections = [
  {
    title: "Overview",
    items: crmModules.filter((item) => item.section === "Overview"),
  },
  {
    title: "Report",
    items: crmModules.filter((item) => item.section === "Report"),
  },
  {
    title: "Management",
    items: crmModules.filter((item) => item.section === "Management"),
  },
  {
    title: "Marketplace",
    items: crmModules.filter((item) => item.section === "Marketplace"),
  },
];

const SalesDemo = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const activeModule = crmModules[activeIndex];

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % crmModules.length);
    }, AUTO_CHANGE_TIME);

    return () => clearInterval(timer);
  }, [activeIndex]);

  const handleModuleClick = (index) => {
    setActiveIndex(index);
  };

  return (
    <>
      <section className="sales-demo-section">
        <div className="sales-demo-container">
          <div className="crm-browser">
            <div className="browser-header">
              <div className="browser-dots">
                <span className="dot red" />
                <span className="dot yellow" />
                <span className="dot green" />
              </div>

              <div className="browser-url">
                redvisiontechnologies.com<span>/</span> {activeModule.slug}
              </div>
            </div>

            <div className="crm-app-shell">
              <div className="crm-topbar">
                <div className="crm-logo-round">
                  <img
                    src={iconfevi}
                    alt="Logo"
                    width="25"
                    height="25"
                    style={{ position: "relative", top: "-2px" }}
                  />
                </div>

                <div className="crm-search">
                  <span>
                    <i className="fa fa-search" aria-hidden="true"></i>{" "}
                    Global Search (Ctrl + G)
                  </span>
                </div>

                <div className="crm-top-actions">
                  <span className="notify">
                    <i className="fa fa-cog" aria-hidden="true"></i>
                  </span>

                  <span className="notify">
                    <i className="fa fa-bell" aria-hidden="true"></i>
                  </span>

                  <span className="crm-user">
                    <img src={profile} alt="Profile" />
                  </span>
                </div>
              </div>

              <aside className="crm-sidebar">
                <div className="crm-menu-list">
                  {sidebarSections.map((section) => (
                    <div className="crm-menu-section" key={section.title}>
                      <div className="crm-side-menu-title">
                        <span>{section.title}</span>
                      </div>

                      {section.items.map((item) => {
                        const moduleIndex = crmModules.findIndex(
                          (moduleItem) => moduleItem.key === item.key
                        );

                        return (
                          <button
                            key={item.key}
                            type="button"
                            className={`crm-menu-item ${
                              activeIndex === moduleIndex ? "active" : ""
                            }`}
                            onClick={() => handleModuleClick(moduleIndex)}
                          >
                            <span
                              className="crm-menu-icon"
                              style={{ background: item.color }}
                            >
                              <i className={item.icon} aria-hidden="true"></i>
                            </span>

                            <span>{item.label}</span>
                          </button>
                        );
                      })}
                    </div>
                  ))}
                </div>
              </aside>

              <main className="crm-content">
                <div className="crm-content-header">
                  <div className="crm-breadcrumb">
                    <span>Dashboard</span>
                    <b>›</b>
                    <span>{activeModule.title}</span>
                  </div>

                  <div className="crm-content-buttons">
                    <button type="button">⚙</button>
                    <button type="button">⋯</button>
                  </div>
                </div>

                <div className="crm-content-body image-preview-body">
                  <div className="crm-image-frame">
                    <img
                      src={activeModule.image}
                      alt={`${activeModule.title} CRM Preview`}
                      className="crm-preview-image"
                      draggable="false"
                    />
                  </div>
                </div>

                <div className="crm-powered">
                  <span>© 2026 Sales Ninja CRM. All Rights Reserved.</span>
                </div>
              </main>
            </div>
          </div>

          <div className="crm-progress">
            {crmModules.map((item, index) => (
              <button
                key={item.key}
                type="button"
                className={activeIndex === index ? "active" : ""}
                onClick={() => handleModuleClick(index)}
                aria-label={`Open ${item.label}`}
              />
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default SalesDemo;



